// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__okhrm","cardSize_XS":"card_cardSize_XS__gpm0j","cardSize_S":"card_cardSize_S__4JYJp","cardSize_M":"card_cardSize_M__wVOtL"};